import { resolveApiUrl } from "../../utils/url/urlResolver";
import type { MediaItem } from "../types/mediaLibraryTypes";
import { mediaTransformer } from "./mediaTransformer";

export type MediaAPIParams = {
  q?: string;
  page?: number;
  mediaTypes?: string[];
  productPortfolios?: string[];
  languages?: string[];
  segments?: string[];
  fetchFavourite?: boolean;
  sortOrder?: "asc" | "desc";
};

export async function fetchMediaAssets(params: MediaAPIParams): Promise<MediaItem[]> {
  const { q, page = 0, mediaTypes, productPortfolios, languages, segments, fetchFavourite, sortOrder } = params;

  const searchParams = new URLSearchParams();

  if (q) {
    searchParams.set("q", q);
  }
  if (page !== undefined) {
    searchParams.set("page", String(page));
  }
  if (mediaTypes?.length) {
    searchParams.set("mediaTypes", mediaTypes.join(","));
  }
  if (productPortfolios?.length) {
    searchParams.set("productPortfolios", productPortfolios.join(","));
  }
  if (languages?.length) {
    searchParams.set("languages", languages.join(","));
  }
  if (segments?.length) {
    searchParams.set("segments", segments.join(","));
  }
  if (fetchFavourite !== undefined) {
    searchParams.set("fetchFavourite", String(fetchFavourite));
  }
  if (sortOrder !== undefined) {
    searchParams.set("asc", String(sortOrder === "asc"));
  }

  const url = `/media-library/search?${searchParams}`;
  const apiUrl = resolveApiUrl(url);

  const response = await fetch(apiUrl, {
    method: "GET",
    credentials: "same-origin",
    mode: "cors",
    referrer: "no-referrer",
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Error status: ${response.status}`);
  }

  const data = await response.json();
  return mediaTransformer(data);
}
